<template>
  <div class="w-full h-full">
    <div class="relative flex flex-col h-full">
      <div class="w-full my-auto text-center">
        <section class="mb-4">
          <img
            class="object-contain w-full max-w-md mx-auto"
            :src="page.bannerImage"
          />
        </section>
        <section class="mb-4">
          <span class="title mb-3 inline-block font-bold"
            >Tutto ciò che ti serve in un solo conto:</span
          >
          <ul class="ist-disc space-y-3 list-inside">
            <li v-for="(line, i) in page.list" :key="i" v-html="line.text" />
          </ul>
        </section>
        <section class="mb-4">
          <div class="flex justify-center -mx-2">
            <app-cta-button
              v-for="cta in page.ctas"
              :key="cta.link"
              v-bind="cta"
            />
          </div>
        </section>
        <section class="mb-4 prose" v-html="page.descrizione" />
        <section class="mb-4">
          <p class="flex items-center" v-if="page.claim">
            <span v-text="page.claim.text" />
            <img class=" h-6" :src="page.claim.logo" />
          </p>
        </section>
        <section class="flex justify-center mb-4"></section>
      </div>
    </div>
  </div>
</template>

<script>
import { axios } from "@/plugins/axios";
export default {
  props: { navigate: { default: null } },
  async beforeRouteEnter(to, from, next) {
    let page;
    try {
      page = await axios.get(`/pageContent${to.path}.json`);
    } catch (error) {
      page = {};
    } finally {
      next(vm => (vm.page = page.data));
    }
  }
};
</script>
<route>
{
  "name": "manifesto",
  "meta": {
      "order": 1,
      "label": "Scopri tutti i vantaggi",
      "hideAsChild": {
        "inline": true,
        "main" : true
      }
  }
}
</route>
<style scoped>
.title {
  font-size: 1.8rem;
}
</style>
